import { ua } from './modules/ua'
import inView from 'in-view'
import smoothscroll from 'smoothscroll-polyfill'
import Swiper from 'swiper/bundle'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  portrait: 'is-portrait',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    // ナビゲーション開閉
    const navTrigger = document.querySelector('.nav-trigger')
    navTrigger.addEventListener('click', () => {
      this.body.classList.toggle(klass.nav)
    })

    inView('.inview').on('enter', (el) => {
      el.classList.add('is-view')
    })
    inView.offset(100)

    // window.addEventListener('scroll', () => {
    //   if (window.scrollY > 200) {
    //     this.body.classList.add('is-scroll')
    //   } else {
    //     this.body.classList.remove('is-scroll')
    //   }
    // })
    //
    // // ナビゲーションを押下時に閉じる
    // Array.from(document.querySelectorAll('.navList a')).forEach((trigger) => {
    //   trigger.addEventListener('click', () => {
    //     this.body.classList.remove(klass.nav)
    //   })
    // })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.siteApp = new App()

  smoothscroll.polyfill()
})

window.addEventListener('load', () => {
  document.querySelector('body').classList.add('is-loaded')
})
